export function normalizeProjectSearch(value) {
    return String(value ?? '')
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .toLocaleLowerCase('cs-CZ')
        .trim();
}

export function filterDropdownProjects(projects, query) {
    const normalizedQuery = normalizeProjectSearch(query);
    if (!normalizedQuery) return projects;

    return projects.filter((project) => normalizeProjectSearch(project.name).includes(normalizedQuery));
}
